import React, { ChangeEvent, Component } from "react";

import "./ShippingAccounts.scss";
import IShipping_Account from "../../../../models/IShipping_Account";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import IShipstationWarehouse from "../../../../models/Shipstation/IShipstationWarehouse";
import IShipstationCarrierDTO from "../../../../models/Shipstation/IShipstationCarrierDTO";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import ISupplierModel from "../../../../models/ISupplierModel";
import INotification from "../../../../models/INotification";
import INewShipping_Account from "../../../../models/INewShipping_Account";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import IShipping_AccountUI from "../../../../models/IShipping_AccountUI";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IUserUI from "../../../../models/IUserUI";
import { Socket } from "socket.io-client";

type Props = {
    shippingAccounts: IShipping_Account[];
    shipstationCarriers: IShipstationCarrierDTO[];
    shipstationWarehouses: IShipstationWarehouse[];
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    updateShippingAccounts: (shippingAccounts: IShipping_AccountUI[] | INewShipping_Account[]) => void;
};

type State = {
    shippingAccounts: IShipping_AccountUI[];
    availableCarriers: IShipstationCarrierDTO[];
    warehouses: IShipstationWarehouse[];
};

export default class ShippingAccounts extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            shippingAccounts: this.props.shippingAccounts,
            availableCarriers: this.filterAvailableCarriers(this.props.shippingAccounts),
            warehouses: this.props.shipstationWarehouses,
        };
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    filterAvailableCarriers = (shippingAccounts: IShipping_Account[]): IShipstationCarrierDTO[] => {
        const allCarriers = this.props.shipstationCarriers;

        const carriersAvailable: IShipstationCarrierDTO[] = [];

        for (const aCarrier of allCarriers) {
            let carrierFound = false;

            for (const shippingAccount of shippingAccounts) {
                if (shippingAccount.shipstation_carrierCode === aCarrier.code) {
                    carrierFound = true;
                }
            }

            if (!carrierFound) {
                carriersAvailable.push(aCarrier);
            }
        }

        return carriersAvailable;
    };

    addShippingAccount = () => {
        const accounts = this.state.shippingAccounts;

        const newShippingAccount: Partial<INewShipping_Account> = {
            is_shipstation: true,
            shipstation_carrierCode: "",
        };

        // @ts-expect-error
        accounts.unshift(newShippingAccount);

        this.setState({
            shippingAccounts: accounts,
        });
    };

    handleChange = (e: ChangeEvent<any>, account: IShipping_AccountUI, index: number) => {
        const value = e.target.value;
        const name = e.target.name;
        const accounts = this.state.shippingAccounts;

        for (const arrAccount of accounts) {
            if (arrAccount.shipstation_carrierCode === account.shipstation_carrierCode) {
                // @ts-expect-error
                arrAccount[name] = value;
            }
        }

        const availableCarriers = this.filterAvailableCarriers(accounts);

        this.setState(
            {
                shippingAccounts: accounts,
                availableCarriers,
            },
            () => {
                this.props.updateShippingAccounts(this.state.shippingAccounts);
            }
        );
    };

    getCarrierOptions = (account: IShipping_AccountUI, index: number): IShipstationCarrierDTO[] => {
        const carrierOptions: IShipstationCarrierDTO[] = [];

        for (const carrier of this.props.shipstationCarriers) {
            let available = true;

            for (const accountDetail of this.state.shippingAccounts) {
                if (
                    accountDetail.shipstation_carrierCode === carrier.code &&
                    accountDetail.shipstation_carrierCode !== account.shipstation_carrierCode
                ) {
                    available = false;
                }
            }

            if (available) {
                carrierOptions.push(carrier);
            }
        }

        return carrierOptions;
    };

    removeAccount = (account: IShipping_AccountUI, index: number) => {
        const shippingAccounts = this.state.shippingAccounts;

        let isSplice = false;

        for (const shippingAccount of shippingAccounts) {
            if (shippingAccount.shipstation_carrierCode === account.shipstation_carrierCode) {
                if (shippingAccount.id) {
                    shippingAccount.deleteFlag = !shippingAccount.deleteFlag;
                } else {
                    isSplice = true;
                }
            }
        }

        if (isSplice) {
            shippingAccounts.splice(index, 1);
        }

        this.setState(
            {
                shippingAccounts,
            },
            () => {
                this.props.updateShippingAccounts(this.state.shippingAccounts);
            }
        );
    };

    render() {
        return (
            <div className={"ShippingAccounts"}>
                <div className="title-row">
                    <OwTitle className={""} title={"shipping_accounts"} tag={"h6"} isUnderline={true} />
                    <div>
                        <OwButton
                            title={"add"}
                            leftIconClass={"fas fa-plus"}
                            fn={this.addShippingAccount}
                            disabled={this.state.shippingAccounts.length === this.props.shipstationCarriers.length}
                        />
                    </div>
                </div>

                <div className={"detail-rows"}>
                    {this.state.shippingAccounts.map((account: IShipping_AccountUI, index: number) => {
                        return (
                            <div key={account.guid} className="detail-row-wrapper">
                                {account.deleteFlag ? (
                                    <div className={"w-100"}>
                                        <OwLabel title={"marked_for_delete"} className={"text-danger"} />
                                    </div>
                                ) : null}

                                <div className={"detail-row"}>
                                    <div className={"w-10 justify-content-center"}>
                                        <i
                                            className={
                                                "fad me-2 pointer " +
                                                (account.deleteFlag ? "fa-undo text-primary" : "fa-trash-alt text-danger")
                                            }
                                            onClick={() => {
                                                this.removeAccount(account, index);
                                            }}
                                        />
                                    </div>

                                    <div className={"w-90"}>
                                        <div className={""}>
                                            <OwLabel title={"carrier"} />
                                            <OwSelectOption
                                                titleProp={"name"}
                                                valueProp={"code"}
                                                selectedOption={account}
                                                selectedOptionProp={"shipstation_carrierCode"}
                                                fn={(e: any) => {
                                                    this.handleChange(e, account, index);
                                                }}
                                                options={this.getCarrierOptions(account, index)}
                                                name={"shipstation_carrierCode"}
                                                showBlankFirst={true}
                                            />
                                        </div>

                                        <div>
                                            <OwLabel title={"warehouse_origin"} />
                                            <OwSelectOption
                                                titleProp={"warehouseName"}
                                                valueProp={"warehouseId"}
                                                selectedOption={account}
                                                selectedOptionProp={"shipstation_warehouseId"}
                                                fn={(e: any) => {
                                                    this.handleChange(e, account, index);
                                                }}
                                                options={this.state.warehouses}
                                                name={"shipstation_warehouseId"}
                                                showBlankFirst={true}
                                            />
                                        </div>

                                        <div className={""}>
                                            <OwLabel title={"account_no"} />
                                            <OwInputWrapper
                                                value={account.account_no}
                                                name={"account_no"}
                                                fn={(e: ChangeEvent<any>) => {
                                                    this.handleChange(e, account, index);
                                                }}
                                            />
                                        </div>

                                        {/*<div>*/}
                                        {/*    <OwCheckbox*/}
                                        {/*        label={"use_vendor_ship_to_as_origin"}*/}
                                        {/*        truthyVal={true}*/}
                                        {/*        falsyVal={false}*/}
                                        {/*        name={"use_vendor_ship_to_as_origin"}*/}
                                        {/*        supplierModel={this.props.supplierModel}*/}
                                        {/*        isSupplierVendorOverride={true}*/}
                                        {/*        checked={account.use_vendor_ship_to_as_origin}*/}
                                        {/*        fn={(e) => {*/}
                                        {/*            this.handleChange(e, account, index);*/}
                                        {/*        }}*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
